export default "/WebApp/dist/assets/svg/black-circle.svg";